import { gql } from '@apollo/client';

export const GENERATE_GOOD_DEAL_ARTICLE_IA = gql`
  mutation GenerateGoodDealArticle($productUrl: URL!) {
    generateAIGoodDealArticle(productUrl: $productUrl) {
      status
    }
  }
`;
